module.exports = __webpack_public_path__ + "img/user-outline-icon.99187307.svg";